export var ENTITY = "settlement";
export var REDUCER_KEY = "SETTLEMENTS_V2";
export var BASE_PATH_ENTITY = "settlements";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
